/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createBackupsTableStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '610px',
  },
  cellHead: {
    textTransform: 'uppercase',
  },
  tableHeadCell: {
    padding: '0 8px',
  },
  tableCell: {
    padding: '19px 10px',
  },
  tableButtonCell: {
    padding: '6px',

    '&:last-child': {
      paddingRight: '0',
    },
  },
  dateTop: {
    color: '#000000',
    marginBottom: '10px',
  },
  backupButton: {
    minWidth: '0',
    padding: '8px',
  },
  deleteAllBackupsButton: {
    marginTop: '12px',
  },
  heading: {
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 700,
  },
}));

export { createBackupsTableStyles };
